{
  "004f5d5275089ec5": "Export My Past Shifts",
  "010077a338ae711d": "What you'll get",
  "04c66ddd3a12f26a": "PBJ Quarters",
  "0a0576d381558739": "No chart data is available for this workplace yet.",
  "1208ec01f223c616": "Previous page",
  "14d74158a8d17afe": "Date Range",
  "1559a79d9a98cc94": "Email My Past Shifts",
  "18e83b61f2fd9ee7": "No shifts available for this view right now.",
  "19766ed6ccb2f4a3": "Cancel",
  "19c73a5cdf346d96": "Professional",
  "24059f06f65217e2": "Email report",
  "29ccb51a8ac08325": "Weekly fill, last-minute demand, and dynamic charge outcomes.",
  "2e544a292f6979ed": "Shift",
  "32334126e7a4727b": "No shifts were found in the selected date range.",
  "34c4406f444e3055": "Unique professionals who have already worked here.",
  "3982f0e7ebe9b019": "Child workplaces",
  "3aaa8e968bd46b42": "There was an error generating your report. Please try again or contact support.",
  "3c81e27e32356966": "Total Clipboard shifts completed at this workplace.",
  "3e69ed92dacf9336": "We could not load reporting trends right now.",
  "50ca140508e4c2fe": "Request a CSV for any time period and get the same full export payload as the legacy workflow, including unique professional IDs and day-by-day hours.",
  "53779f0aaec9f64b": "All child workplaces are included by default. Select one or more to narrow the report.",
  "54a0e8c17ebb21a1": "Error",
  "6581fd2fc435ddf1": "Lifetime Contracted Professionals",
  "6a74f97da23273c8": "Your report download has started.",
  "6c68ad180780bcaa": "Download report",
  "730fa2bbb7eed5be": "Your report will be emailed to you in just a few minutes.",
  "7602b82667695f57": "Combine the selected workplaces into a single file instead of one file per workplace.",
  "784d9cd76a8882e8": "Request export for child workplaces",
  "7c7523eda3b9df7e": "Week of shift start",
  "7d9eb7acb13e2462": "Close",
  "7f6ef2a4b8b68158": "Request report",
  "84a6279baecd797d": "Use export to inspect the full history",
  "868dd3bb3de9cd6d": "Next 48 hours.",
  "9ad3c6fd490260a2": "What's included in this report",
  "9c30df66653ecc6c": "Consolidate into one report",
  "9d9afc4eb9108e8d": "Reports include the start and end dates selected, unique professional IDs, daily hours with midnight splits, and the rest of the existing export payload.",
  "aaf89a2e8dd2e9c7": "Page {{page}}",
  "abf8fcb96d8d7ccb": "Page {{page}} of {{totalPages}}",
  "b1fa104b9bf0635e": "Reporting",
  "b70c92965b2bef81": "Upcoming Filled Shifts",
  "b8afa9ad74a3bcdf": "Q{{quarterNumber}} {{fiscalYear}}",
  "b9f85f36d4fd1e96": "We couldn't load this metric right now.",
  "bcd892c6af2e7a95": "Upcoming Unfilled Shifts",
  "c08ac736a5e29c29": "Next page",
  "c0bbbd310ce1d6a3": "Open My Professionals",
  "c2b7ea6e50679e34": "Request export",
  "c522ba8398594f8c": "Booked shifts starting within the next 48 hours.",
  "c7f761b38b197daa": "{{count}} selected",
  "d241f9dd52b2518f": "All child workplaces",
  "d56bd8d171bea796": "Open coverage needs in the next 48 hours.",
  "d63b2b691e7e7479": "File format",
  "e4bb9f1ece9af926": "Start",
  "e96595c5612813ad": "We'll generate your {{fileType}} file for the selected period and email it to the address associated with your account.",
  "ee89233169887439": "Lifetime Clipboard Shifts",
  "f00b68c521eff8c8": "We'll generate a CSV for the selected period and email it to the address associated with your account.",
  "f11f7b221d0149fa": "Export Past Shifts",
  "f308f941bd16022b": "Performance Trends",
  "f4db1e48476f6075": "End",
  "ff7912a16f6ad42f": "Email Child Workplace Shifts"
}
